import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { catchError, finalize, map, Observable, of } from 'rxjs';
import { LessonPicture } from '../../data/models/LessonPicture';
import { API } from '../../data/api';
import { environment } from '../../../environments/environment';
import { SharedDataService } from '../../helper/services/shared-data.service';

@Injectable({
  providedIn: 'root'
})
export class LessonPictureService {
  constructor(private networkingService: NetworkingService, private sharedDataService: SharedDataService) { }

  getLessonPictureList(): Observable<LessonPicture[]> {
    return this.networkingService.getRequest<LessonPicture[]>(API.lessonPictureList).pipe(
        map((lessonPictures: LessonPicture[]) => {
          return lessonPictures.map((lessonPicture) => ({
            ...lessonPicture,
            imageData: `${environment.url}/${environment.backendVersion}/${API.lessonPictureDownload(lessonPicture.id)}`,
          }))
        }),
        catchError((error) => {
          return of([]);
        }),
        finalize(() => {
          this.sharedDataService.toggleProgressBarOff();
        })
      );
  }

  getLessonPictureDetails(id: string): Observable<LessonPicture> {
    const endpoint = API.lessonPictureDetails(id);
    return this.networkingService.getRequest<LessonPicture>(endpoint).pipe(
        map((lessonPicture: LessonPicture) => ({
          ...lessonPicture,
          imageData: `${environment.url}/${environment.backendVersion}/${API.lessonPictureDownload(lessonPicture.id)}`,
        })),
        finalize(() => {
          this.sharedDataService.toggleProgressBarOff();
        })
      );
  }
}